module.exports = __webpack_public_path__ + "img/IMG_7231.a8950142.webp";